import React, {useContext} from 'react';
import './App.css';
import KalenisRouter from './common/KalenisRouter.js'
// import NotificationManager from './ui/notifications/NotificationManager'

import {AppRoot} from 'kalenis-portal-frontend-main'

//temp: remove when upgrade tailwind
const library_css = [
  'bg-green-200',
  'text-green-800', 
  'border-green-400'
]
function App() {
  

  return (

    // <NotificationManager>
      <AppRoot>
  
        <KalenisRouter className="bg-background" />
  
        
        {/* </Theme> */}
      </AppRoot>
    // </NotificationManager>


  );
}

export default App;
